import { createSelector } from '@reduxjs/toolkit';
import { selectDiscountPromoSearchTypeValue } from './selectDiscountPromoSearchTypeValue';
import { selectDiscountPromoSearchTypeOptions } from './selectDiscountPromoSearchTypeOptions';
import { NBSP } from 'shared/constants/symbols';

export const selectDiscountPromoSearchTypeFilter = createSelector(
  [selectDiscountPromoSearchTypeValue, selectDiscountPromoSearchTypeOptions],
  (value, options) => ({
    label: `Скидки и акции от${NBSP}застройщиков`,
    value,
    options,
  }),
);
